import styled from 'styled-components';

const GroupsLabel = styled.div`
  color: ${props => props.theme.fontTertiary};
  font-size: ${props => props.theme.font.fontSm};
  margin-top: 16px;
`;

export default GroupsLabel;
